import React, { useState } from "react";
import { Button, message, Space, Input, Empty, App, Typography } from "antd";
import { useDispatch } from "react-redux";
import { getDialogByBailiff } from "store/bailiff/dev/dev.action";
import CardDraftSegmentDebug from "component/cards/draft/card_draft_segment_debug";
import TriggerInit from "./trigger/trigger_audio";
import AudioUrl from "component/audio/audio_url";
import { useSelector } from "react-redux";
import { draftDialogAudioUrlSelector } from "store/bailiff/draft/dialog/draft_dialog.selector";
import AudioUrlDebug from "component/audio/audio_url_debug";

// Import the LoginPage component

const DevScreen = () => {
  // -------------------------- VAR -----------------------------
  const { message } = App?.useApp();
  // -------------------------- STATE ---------------------------
  const [bailiff, setBailiff] = useState("");
  const [loading, setLoading] = useState(false);
  const [slot, setSlot] = useState("");
  const [data, setData] = useState(null);
  // -------------------------- REDUX ---------------------------
  const dispatch = useDispatch();
  const sentences = data?.sentences || [];
  const url = useSelector(draftDialogAudioUrlSelector);
  console.log({ sentences });
  // -------------------------- FUNCTION ------------------------
  const handleGenerate = () => {
    if (!bailiff || !slot) return message.error("Dữ liệu không hợp lệ");
    setLoading(true);
    dispatch(
      getDialogByBailiff({ bailiff, slot }, (res) => {
        setLoading(false);
        if (res?.status === 200) {
          setData(res?.data);
        } else {
          message.error(res?.data);
        }
      }),
    );
  };
  // -------------------------- EFFECT --------------------------
  // -------------------------- DATA FUNCTION -------------------
  // -------------------------- RENDER --------------------------
  const renderSearch = () => {
    return (
      <div className="flex flex-row gap-1">
        <Input
          value={bailiff}
          onChange={(e) => setBailiff(e?.target?.value)}
          placeholder="Nhập bailiff Id"
          disabled={loading}
        />
        <Input
          value={slot}
          onChange={(e) => setSlot(e?.target?.value)}
          placeholder="Nhập Slot"
          disabled={loading}
        />
        <Button loading={loading} type="primary" onClick={handleGenerate}>
          Lấy dữ liệu
        </Button>
      </div>
    );
  };

  const renderLists = () => {
    if (sentences?.length === 0) return <Empty />;
    return (
      <div className="flex flex-col gap-3">
        {sentences?.map((item, index) => {
          const first = index === 0;
          const classBorderTop = !first ? "border-b-[1px] border-gray-300" : "";
          return (
            <div key={index}>
              <CardDraftSegmentDebug data={item} />
            </div>
          );
        })}
      </div>
    );
  };

  // -------------------------- MAIN ----------------------------
  return (
    <div
      className="mx-auto flex max-w-[800px] flex-col gap-5 bg-white"
      style={{ width: "100%", padding: 20, minHeight: "100vh" }}
    >
      <Typography.Title level={3}>Debug Bailiff</Typography.Title>

      {renderSearch()}
      {renderLists()}
      {url && data && <AudioUrlDebug url={url} detail={data} />}
      <TriggerInit bailiffId={bailiff} slot={slot} />
    </div>
  );
};

export default DevScreen;
